export default "__VITE_ASSET__KS7dc_UH__"